module.exports = __webpack_public_path__ + "img/fm-Path 37 Copy@3x.75326a08.png";